import React from 'react';

import {Owed} from 'containers/FrontDesk/components/shared';

import './styles.css';

const BookingSetBalance = ({
  bookingSetRentAndOneOffBalance,
  bookingSetDepositBalance
}) => (
  <div className="BookingSetBalance colab-centered-v colab-row-space-between">
    <div>
      <div className="label">Charges & Payments</div>
      <div className="colab-bold">
        <Owed amount={bookingSetRentAndOneOffBalance} />
      </div>
    </div>

    <div>
      <div className="label">Deposit</div>
      <div className="colab-bold">
        <Owed amount={bookingSetDepositBalance} />
      </div>
    </div>
  </div>
);

export default BookingSetBalance;
